import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./PrototypeContainer.scss";
import PrototypeDetail from "../Casas-Velasur/PrototypeDetail/PrototypeDetail";
import PrototypeCarousel from "../PrototypeCarousel/PrototypeCarousel";
import {
  FloorType,
  PrototypeTypes,
  getPrototype,
} from "../../utils/prototypes";
import { CSSTransition } from "react-transition-group";
import FormPrototype from "../Modal/FormPrototype";

const PrototypeContainer = ({ setModalConfigProps }) => {
  const { t, i18n } = useTranslation();
  const [showModal, setModal] = useState(false);
  const [namePrototype, setNamePrototype] = useState("");

  const AcaciaI = getPrototype(PrototypeTypes.AcaciaI);
  const AcaciaIV = getPrototype(PrototypeTypes.AcaciaIV);
  const AcaciaXIX = getPrototype(PrototypeTypes.AcaciaXIX);

  const handlePrototype = (name) => {
    setNamePrototype(name);
    setModal(true);
  };

  const renderPrototype = (prototype) => (
    <div className={`prototype-container ${prototype === AcaciaIV ? "brown" : ""}`}>
      <img
        className="iso"
        src="/assets/casas-velasur/svg-iso-velasur.svg"
        alt=""
      />
      <h2>{t(prototype.name)}</h2>
      <div className="text-ground">
  <p>
    {t("Terreno")}: {
      i18n.language.startsWith('en') 
        ? `${prototype.terrenoSqFt} ${t("units.squareFeet")}` 
        : `${prototype.terreno} ${t("units.squareMeters")}`
    }
  </p>
  <p>
    {t("Construcción")}: {
      i18n.language.startsWith('en')
        ? `${prototype.construccionSqFt} ${t("units.squareFeet")}`
        : `${prototype.construccion} ${t("units.squareMeters")}`
    }
  </p>
</div>
      <div className="prototype-container-detail">
        <div className="container-carousel">
          <PrototypeCarousel
            images={prototype.gallery}
            setModalConfigProps={setModalConfigProps}
          />
        </div>
        <div className="container-detail">
          <PrototypeDetail
            floorType={t(prototype.floor[FloorType.LowFloor].title)}
            surface={prototype.floor[FloorType.LowFloor].surface}
            features={prototype.floor[FloorType.LowFloor].features.map(f => ({
              characteristics: t(f.characteristics),
              additional: f.additional ? t(f.additional) : "",
            }))}
            floorImage={prototype.floor[FloorType.LowFloor].floorImage}
          />
        </div>
        <div className="container-detail">
          <PrototypeDetail
            floorType={t(prototype.floor[FloorType.TopFloor].title)}
            surface={prototype.floor[FloorType.TopFloor].surface}
            features={prototype.floor[FloorType.TopFloor].features.map(f => ({
              characteristics: t(f.characteristics),
              additional: f.additional ? t(f.additional) : "",
            }))}
            floorImage={prototype.floor[FloorType.TopFloor].floorImage}
          />
        </div>
      </div>
      <button onClick={() => handlePrototype(t(prototype.name))}>
        {t("ESTOY INTERESADO")}
      </button>
    </div>
  );

  return (
    <>
      <CSSTransition
        in={showModal}
        timeout={200}
        classNames="show"
        unmountOnExit
      >
        <FormPrototype setModal={setModal} prototype={namePrototype} />
      </CSSTransition>

      
      {renderPrototype(AcaciaIV)}
      {renderPrototype(AcaciaXIX)}
      {renderPrototype(AcaciaI)}
    </>
  );
};

export default PrototypeContainer;
